import { useEffect, useState } from "react";
import { useRange } from "react-instantsearch-hooks";
import * as Slider from "@radix-ui/react-slider";

import "./RangeSlider.css";

export function RangeSlider({ disabled, ...props }) {
  const { range: hRange } = useRange({ attribute: "highest_price" });
  const { range: lRange } = useRange({ attribute: "lowest_price" });
  const from = lRange.min;
  const to = hRange.max;
  const { range, canRefine, refine } = useRange(props);
  const { min, max } = range;
  const [value, setValue] = useState(props.initMinMax || [min, max]);
  const [tempValue, setTempValue] = useState(props.initMinMax || [min, max]);

  useEffect(() => {
    setValue([from, to]);
    if (!disabled) {
      setTempValue([from, to]);
    }
  }, [from, to, disabled]);

  useEffect(() => {
    if (disabled) {
      refine([min, max]);
    } else {
      refine(tempValue);
    }
  }, [disabled]);

  return (
    <Slider.Root
      className="slider-root"
      min={min}
      max={max}
      value={value}
      onValueChange={setValue}
      onValueCommit={refine}
      disabled={!canRefine || disabled}
    >
      <Slider.Track className="slider-track">
        <Slider.Range className="slider-range" />
      </Slider.Track>
      <Slider.Thumb className="slider-thumb" />
      <Slider.Thumb className="slider-thumb" />
    </Slider.Root>
  );
}
